export default "__VITE_ASSET__YKLBcpYp__"